import {
  AncillaryPostBookingPurchaseResponse,
  AncillaryPostBookingPurchaseStateEnum,
  AncillaryPostBookingPurchaseResponseEnum,
  CFAR_POST_BOOKING_COMPLETE_BUY,
  CfarOffer,
} from "redmond";
import { delay, put, select } from "redux-saga/effects";
import { actions } from "../../actions";
import Logger from "../../../../helpers/Logger";
import purchasePostBookingOffer from "../../../../api/v2/ancillary/purchasePostBookingOffer";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { cfarPostBookingOfferSelector } from "../../reducer/selectors/postBooking";

export function* purchaseCfarPostBookingOfferSaga(
  props: actions.IPurchaseCfarPostBookingOffer
) {
  const { request, trackingProperties } = props;

  const cfarOffer: CfarOffer | undefined = yield select(
    cfarPostBookingOfferSelector
  );
  const cfarPerPax = cfarOffer?.premiumPerPax.fiat.value;

  const POLL_DELAY_MS = 1000;
  const MAX_DELAY_MS = 60000;
  const maxPolls = MAX_DELAY_MS / POLL_DELAY_MS;

  try {
    var response: AncillaryPostBookingPurchaseResponse =
      yield purchasePostBookingOffer({
        state: {
          PostBookingState: AncillaryPostBookingPurchaseStateEnum.ScheduleQuote,
        },
        request: request,
      });

    var retyAttempts = 0;
    while (retyAttempts++ < maxPolls) {
      switch (response.PostBookingOfferPurchaseResponseV2) {
        case AncillaryPostBookingPurchaseResponseEnum.Polling:
          yield delay(POLL_DELAY_MS);
          response = yield purchasePostBookingOffer({
            state: response.state,
            request: request,
          });
          break;
        case AncillaryPostBookingPurchaseResponseEnum.PurchaseSuccess:
          trackEvent({
            eventName: CFAR_POST_BOOKING_COMPLETE_BUY,
            properties: {
              cfar_per_pax: cfarPerPax,
              post_booking_cfar_choice: 1,
              success: true,
              ...trackingProperties,
              ...response.trackingProperties,
            },
          });
          yield put(
            actions.setCfarPostBookingOfferPurchaseResponse(response)
          );
          return;
        case AncillaryPostBookingPurchaseResponseEnum.PaymentFailed:
          trackEvent({
            eventName: CFAR_POST_BOOKING_COMPLETE_BUY,
            properties: {
              cfar_per_pax: cfarPerPax,
              post_booking_cfar_choice: 1,
              success: false,
              ...trackingProperties,
            },
          });
          yield put(
            actions.setCfarPostBookingOfferPurchaseCallStateFailed(response)
          );
          return;
      }
    }
    throw new Error("Purchase Polling failed with too many attempts");
  } catch (e) {
    trackEvent({
      eventName: CFAR_POST_BOOKING_COMPLETE_BUY,
      properties: {
        cfar_per_pax: cfarPerPax,
        post_booking_cfar_choice: 1,
        success: false,
        failure_reason: (e as Error).message,
        ...trackingProperties,
      },
    });
    yield put(
      actions.setCfarPostBookingOfferPurchaseCallStateFailed({
        PostBookingOfferPurchaseResponseV2:
          AncillaryPostBookingPurchaseResponseEnum.PaymentFailed,
      })
    );
    Logger.debug(e);
  }
}
